/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Contact_Erasure_Confirmation_WrongInputs */

const en_error_contact_erasure_confirmation_wrong = /** @type {(inputs: Error_Contact_Erasure_Confirmation_WrongInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Type the word to confirm the erasure.`)
};

/**
* | output |
* | --- |
* | "Type the word to confirm the erasure." |
*
* @param {Error_Contact_Erasure_Confirmation_WrongInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_contact_erasure_confirmation_wrong = /** @type {((inputs?: Error_Contact_Erasure_Confirmation_WrongInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Contact_Erasure_Confirmation_WrongInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_contact_erasure_confirmation_wrong(inputs)
});